module.exports = __webpack_public_path__ + "img/006-carnival-mask.e210a004.png";